import {AfterContentInit, Component, ContentChildren, EventEmitter, OnInit, Output, QueryList} from '@angular/core';
import {StepPageComponent} from '../step-page/step-page.component';

@Component({
  selector: 'ecp-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.css']
})
export class StepsComponent implements OnInit, AfterContentInit {
  stepInfo: Array<any> = [];
  stepCurrent: number = 0;
  @Output() ecpOnloadAfter = new EventEmitter(); // ç»ä»¶è½½å¥ååè°
  @Output() ecpAfterChange = new EventEmitter(); // åæ¢æ­¥éª¤æ¶çåè°
  @Output() ecpFinishChange = new EventEmitter(); // åæ¢å°æåä¸æ­¥æ¶åè°
  @Output() ecpCancerAfter = new EventEmitter(); // ç¹å»åæ¶æ¶åè°


  @ContentChildren(StepPageComponent) steps: QueryList<StepPageComponent>;


  pre() {
    const self = this;
    self.stepCurrent = (self.stepCurrent - 1);
    if (self.stepCurrent <= 0) {
      self.stepCurrent = 0;
    }


    self.ecpAfterChange.emit(self.stepCurrent);
  }

  next() {
    const self = this;
    self.stepCurrent = (self.stepCurrent + 1);
    if (self.stepCurrent >= self.stepInfo.length) {
      self.stepCurrent = 0;
    }


    self.ecpAfterChange.emit(self.stepCurrent);
  }

  last() {
    const self = this;

    self.ecpAfterChange.emit(self.stepCurrent);
    self.ecpFinishChange.emit();
  }

  first() {
    const self = this;
    self.stepCurrent = 0;
    self.ecpAfterChange.emit(self.stepCurrent);
    self.ecpFinishChange.emit();
  }


  cancer() {
    const self = this;

    self.ecpCancerAfter.emit(self.stepCurrent);
  }


  goTo(current) {
    const self = this;

    self.stepCurrent = current;
  }


  constructor() {
  }

  ngOnInit() {
    const self = this;
    this.ecpOnloadAfter.emit(self.stepCurrent);
  }


  ngAfterContentInit(): void {
    const self = this;
    // console.log(' this.steps this.steps', self.steps);
    const stepArry = this.steps.toArray();

    // console.log(' stepArrystepArrystepArry', stepArry);
    let obj;
    this.stepInfo = [];


    stepArry.forEach(function(value, index, array) {
      self.stepInfo.push(value.title);
      //  console.log(self.stepInfo);
    });


  }

}
